// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div class="bottom-button" :class="{on: toggled}" ref="bottomButton">
    <a v-on:click='clicked'>
      <svg :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25" cy="25" :r="this.radius" stroke="black" stroke-witdh="3" fill="#1E1E1E"/>
        <path :fill-rule="fillRule" :clip-rule="clipRule" :d="d" fill="#FFFFFF"/>
      </svg>
    </a>
    <div class="hint">{{label}}</div>
  </div>
</template>

<style lang="scss">
  .bottom-button {
    width: 42px;
    height: 42px;
    position: relative;
    display: inline-block;
    user-select: none;
    margin: 0 5px;
    @media screen and (max-width: 599px){
      width: 50px;
      height: 50px;
    }
  }
  .bottom-button svg {
    width: 100%;
    height: 45px;
    min-width: 50px;
    @media screen and (max-width: 599px) and (min-width: 400px){
      min-width: 50px;
      height: 55px;
    }
    @media screen and (max-width: 399px){
      height: 50px;
      min-width: 40px;
    }
    //@media screen and (max-width: 359px){
    //  min-width: 30px;
    //}
  }
  @media (orientation: landscape) and (max-width:499px){
    .bottom-button svg{
      width: 55px;
      height: 55px;
    }
  }
  .bottom-button.on img {
    filter: opacity(1);
  }
  .bottom-button .hint {
    display: none;
    position: absolute;
    bottom: 100%;
    color: white;
    width: 120px;
    font-size: 12px;
    text-align: center;
    left: -80%;
    line-height: 35px;
    background: rgba(16, 20, 32, 0.7);
    backdrop-filter: blur(16px);
    margin-bottom: 5px;
    border-radius: 4px;
  }
  .bottom-button{
    &.on{
      svg{
        path{
          fill:#FFA751;
        }
      }
    }
  }
  .bottom-button:hover .hint {
    display: block;
    font-family: Proxima_Bold;
  }
</style>

<script>
export default {
  data: function () {
    return {
      windowWidth: window.innerWidth,
      radius: 25
    }
  },
  name: 'bottom-button',
  props: ['label', 'toggled', 'd', 'viewBox', 'fillRule', 'clipRule', 'fill'],
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    clicked: function () {
      var b = !this.toggled
      this.$emit('clicked', b)
    },
    onResize () {
      this.windowWidth = window.innerWidth
      if (this.windowWidth < 599) {
        this.radius = 25
      } else {
        this.radius = 29
      }
    }
  }
}
</script>
